import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"
import type { UseFormReturn } from "react-hook-form"
import { FormProvider } from "react-hook-form"

import { WAREHOUSE_TYPE_TO_LABEL } from "../../constants"

import { WarehouseCompaniesFilter } from "./WarehouseCompaniesFilter"
import { WarehouseFilterSelectField } from "./WarehouseFilterSelectField"

import { StatusFilter } from "@/components/common/Filters"
import { InstructionStatus } from "@/screens/ManageProducts/components/Instructions/types"
import type { WarehouseFilterFormValues } from "@/screens/Warehouses/types"

interface WarehouseFilterProps {
  onFilterChange: (name: string, value: any) => void
  methods: UseFormReturn<WarehouseFilterFormValues, any, undefined>
}

export const WarehouseFilter: FC<WarehouseFilterProps> = ({ onFilterChange, methods }) => {
  return (
    <FormProvider {...methods}>
      <WarehouseFilterSelectField
        name='types'
        label='Warehouse Type'
        control={methods.control}
        onFilterChange={onFilterChange}
        optionList={[...WAREHOUSE_TYPE_TO_LABEL.entries()].map(([key, value]) => ({
          label: value,
          value: key,
        }))}
      />
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        Status
      </Typography>
      <Divider />
      <StatusFilter
        name={"isActive" as never}
        data={Object.values(InstructionStatus)}
        control={methods.control}
        onFilterChange={onFilterChange}
        multiple={false}
        testId='warehouse-status-filter'
      />
      <Box className='grow overflow-hidden'>
        <WarehouseCompaniesFilter onFilterChange={onFilterChange} />
      </Box>
    </FormProvider>
  )
}
